import { atom } from "jotai";

export const globalParamsAtom = atom<any>({
  page: 1,
  perPage: 50,
  sortBy: "createAt",
  sortDirection: "desc",
  type: undefined,
});
